/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SearchResultDisplayType = {
    Inline: 'Inline',
    List: 'List'
} as const;
export type SearchResultDisplayType = typeof SearchResultDisplayType[keyof typeof SearchResultDisplayType];


export function SearchResultDisplayTypeFromJSON(json: any): SearchResultDisplayType {
    return SearchResultDisplayTypeFromJSONTyped(json, false);
}

export function SearchResultDisplayTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchResultDisplayType {
    return json as SearchResultDisplayType;
}

export function SearchResultDisplayTypeToJSON(value?: SearchResultDisplayType | null): any {
    return value as any;
}

